import React, { useState, useRef, useEffect, useContext } from 'react';
import AddCard from './AddCard';
import styles from './CreditCard.module.css';
import { WelletContext } from '../../context/WelletContext';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Skeleton } from '@mui/material';
import CardBrandIcons from './CardBrandIcons';
import CardBrandBackgroundImage from './CardBrandBackgroundImage';

const CreditCardList = ({ onCardIdChange }) => {
  const welletContext = useContext(WelletContext);
  const [currentCardId, setCurrentCardId] = useState(null);
  const [loadingCards, setLoadingCards] = useState(true);
  const [cards, setCards] = useState([]);
  const addCardRef = useRef(null);

  const cardStyle = (index, brand) => ({
    backgroundImage: `url(${CardBrandBackgroundImage({ brand })})`,
    border: index === currentCardId ? '2px solid #1D9BF0' : '1px solid transparent',
  });

  const getCards = async () => {
    setLoadingCards(true);
    try {
      const response = await welletContext.apis.tickets.get('/customer/cards/');
      setCards(response.data);

      if (response.data && response.data.length > 0) {
        setCurrentCardId(0);
        onCardIdChange(response.data[0].token);
      }
    } catch (error) {
      console.error(error);
    }
    setLoadingCards(false);
  };

  const onChangeSlide = (i) => {
    if (i >= cards.length) return;
    setCurrentCardId(i);
    onCardIdChange(cards[i].token);
  };

  useEffect(() => {
    getCards();
  }, []);

  return (
    <div className={`${styles.sliderContainer} pl-4`}>
      <Swiper
        spaceBetween={25}
        slidesPerView={'auto'}
        onSlideChange={(e) => onChangeSlide(e.activeIndex)}
      >
        {loadingCards ? (
          <>
            <SwiperSlide id='1'>
              <div className={styles.card}>
                <Skeleton
                  variant='rectangular'
                  sx={{
                    bgcolor: 'grey.900',
                    width: '300px',
                    height: '180px',
                    borderRadius: '.4rem',
                  }}
                />
              </div>
            </SwiperSlide>
            <SwiperSlide id='2'>
              <div className={styles.card}>
                <Skeleton
                  variant='rectangular'
                  sx={{
                    bgcolor: 'grey.900',
                    width: '300px',
                    height: '180px',
                    borderRadius: '.4rem',
                  }}
                />
              </div>
            </SwiperSlide>
          </>
        ) : (
          <>
            {cards.map(
              ({ id, last4, brand, country, expiryMonth, expiryYear, cardholderName }, index) => (
                <SwiperSlide key={index}>
                  <div className={styles.card} style={cardStyle(index, brand)}>
                    <div className={styles.delantera}>
                      <div className={styles.logoYChip}>
                       
                        <CardBrandIcons brand={brand} />
                      </div>

                      <div>
                        <div className={styles.grupo}>
                          <p className={styles.numero}>**** **** **** **** {last4}</p>
                        </div>
                        <div className={styles.flexbox}>
                          <div className={styles.grupo}>
                            <p className={styles.label}>Card Holder Name</p>
                            <p className={styles.nombre}>{cardholderName}</p>
                          </div>
                          <div className={styles.grupo}>
                            <p className={styles.label}>Expiry Date</p>
                            <p className={styles.expiracion}>
                              <span className={styles.mes}>
                                {expiryMonth.toString().padStart(2, '0')}
                              </span>{' '}
                              / <span className={styles.year}>{expiryYear}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ),
            )}

            <SwiperSlide>
              <AddCard ref={addCardRef} />
            </SwiperSlide>
          </>
        )}
      </Swiper>
    </div>
  );
};

export default CreditCardList;